import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/Inicio/logo.webp';
import React, { useState, useEffect } from 'react';
import useWindowSize from '../hooks/useWindowSize';
import { useTranslation } from 'react-i18next';

export const Header = () => {
  const { t, i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { isMobile } = useWindowSize();
  const currentPath = location.pathname;

  // Determinar si es tablet (entre 768px y 1023px)
  const isTablet = !isMobile && window.innerWidth < 1024;

  // Detectar el scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 🔥 Cada vez que cambie la ruta, hacer scroll al inicio y cerrar menú
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false); // Siempre cerramos el menú al cambiar de ruta
  }, [location.pathname]);

  const isActivePath = (path) => {
    return path === '/agenda/1' ? currentPath.startsWith('/agenda') : currentPath === path;
  };

  const getLinkStyle = (path) => ({
    fontSize: isMobile ? '16px' : isTablet ? '13px' : '13px',
    fontFamily: 'Raleway',
    color: '#152b5a',
    lineHeight: '20px',
    textDecoration: 'none',
    fontWeight: isScrolled ? '500' : 'normal',
    borderBottom: isActivePath(path) ? '2px solid #152b5a' : 'none',
    paddingBottom: '3px',
    transition: 'border-bottom 0.3s ease',
  });

  // const toggleLanguage = () => {
  //   const next = i18n.language && i18n.language.startsWith('es') ? 'en' : 'es';
  //   i18n.changeLanguage(next);
  // };

  return (
    <header
      style={{
        padding: isMobile ? '10px 20px' : isTablet ? '15px 30px' : '20px 50px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: !isScrolled ? '#ffffff' : 'rgba(255, 255, 255, 0.95)',
        position: 'sticky',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        transition: 'all 0.3s ease',
        boxShadow: isScrolled ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
        height: isMobile ? 'auto' : isTablet ? 'auto' : '10vh',
      }}
    >
      <div
        style={{
          width: isScrolled
            ? isMobile
              ? '150px'
              : isTablet
                ? '180px'
                : '200px'
            : isMobile
              ? '200px'
              : isTablet
                ? '220px'
                : '252px',
          transition: 'all 0.3s ease',
        }}
      >
        <Link to="/">
          <img
            src={logo}
            alt="Logo"
            style={{
              width: isMobile ? '70%' : '70%',
              height: 'auto',
              transition: 'all 0.3s ease',
            }}
          />
        </Link>
      </div>

      {/* Menú Hamburguesa solo para Móvil */}
      {isMobile && (
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{
            background: 'none',
            border: 'none',
            padding: '10px',
            cursor: 'pointer',
            zIndex: 1001,
          }}
        >
          <div
            style={{
              width: '25px',
              height: '2px',
              backgroundColor: '#152b5a',
              margin: '6px 0',
              transition: '0.4s',
              transform: isMenuOpen ? 'rotate(-45deg) translate(-5px, 6px)' : 'none',
            }}
          />
          <div
            style={{
              width: '25px',
              height: '2px',
              backgroundColor: '#152b5a',
              margin: '6px 0',
              opacity: isMenuOpen ? 0 : 1,
              transition: '0.4s',
            }}
          />
          <div
            style={{
              width: '25px',
              height: '2px',
              backgroundColor: '#152b5a',
              margin: '6px 0',
              transition: '0.4s',
              transform: isMenuOpen ? 'rotate(45deg) translate(-5px, -6px)' : 'none',
            }}
          />
        </button>
      )}

      <nav
        style={{
          position: isMobile ? 'fixed' : 'static',
          top: isMobile ? '0' : 'auto',
          right: isMobile ? '0' : 'auto',
          bottom: isMobile ? '0' : 'auto',
          width: isMobile ? (isMenuOpen ? '100%' : '0') : 'auto',
          height: isMobile ? '100vh' : 'auto',
          backgroundColor: isMobile ? '#ffffff' : 'transparent',
          transition: 'all 0.3s ease',
          overflow: 'hidden',
          boxShadow: isMobile && isMenuOpen ? '-2px 0 5px rgba(0,0,0,0.1)' : 'none',
          zIndex: 1000,
        }}
      >
        <ul
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            listStyle: 'none',
            margin: '0',
            padding: isMobile ? '80px 20px' : '0',
            gap: isMobile ? '0' : isTablet ? '25px' : '40px',
            justifyContent: 'flex-end',
            alignItems: isMobile ? 'flex-start' : 'center',
          }}
        >
          {isMobile ? (
            // Vista móvil con líneas divisorias
            <>
              <li
                style={{
                  width: '100%',
                  borderBottom: '1px solid #e5e7eb',
                  paddingBottom: '15px',
                  paddingTop: '15px',
                }}
              >
                <Link to="/" style={getLinkStyle('/')}>
                  {t('nav.home')}
                </Link>
              </li>
              <li
                style={{
                  width: '100%',
                  borderBottom: '1px solid #e5e7eb',
                  paddingBottom: '15px',
                  paddingTop: '15px',
                }}
              >
                <Link to="/nosotros" style={getLinkStyle('/nosotros')}>
                  {t('nav.about')}
                </Link>
              </li>
              <li
                style={{
                  width: '100%',
                  borderBottom: '1px solid #e5e7eb',
                  paddingBottom: '15px',
                  paddingTop: '15px',
                }}
              >
                <Link to="/oportunidades" style={getLinkStyle('/oportunidades')}>
                  {t('nav.opportunities')}
                </Link>
              </li>
              <li
                style={{
                  width: '100%',
                  borderBottom: '1px solid #e5e7eb',
                  paddingBottom: '15px',
                  paddingTop: '15px',
                }}
              >
                <Link to="/hub" style={getLinkStyle('/hub')}>
                  {t('nav.hub')}
                </Link>
              </li>
              <li
                style={{
                  width: '100%',
                  borderBottom: '1px solid #e5e7eb',
                  paddingBottom: '15px',
                  paddingTop: '15px',
                }}
              >
                <Link
                  to="https://grewhubtalks.com/"
                  style={getLinkStyle('https://grewhubtalks.com/')}
                >
                  {t('nav.talks')}
                </Link>
              </li>
              {/* <li
                style={{
                  width: '100%',
                  borderBottom: '1px solid #e5e7eb',
                  paddingBottom: '15px',
                  paddingTop: '15px',
                }}
              >
                <button
                  onClick={toggleLanguage}
                  style={{
                    ...getLinkStyle('lang'),
                    border: '1px solid #697fa7',
                    backgroundColor: '#ffffff',
                    padding: '5px 10px',
                    borderRadius: '0',
                    cursor: 'pointer',
                    fontSize: '10px',
                    fontFamily: 'Raleway',
                    fontWeight: 'normal',
                    textAlign: 'center',
                    lineHeight: '13px',
                    display: 'block',
                    width: 'auto',
                  }}
                >
                  {i18n.language && i18n.language.startsWith('es') ? t('lang.en') : t('lang.es')}
                </button>
              </li> */}
              <li style={{ width: '100%', marginTop: '15px' }}>
                <a
                  href="https://intranet.grewhub.com/welcome"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    width: '108px',
                    height: '31px',
                    padding: '0px 8px',
                    border: '1px solid #697fa7',
                    boxSizing: 'border-box',
                    opacity: 0.73,
                    backgroundColor: '#ecf0ef',
                    color: '#152b5a',
                    fontSize: '10px',
                    fontFamily: 'Raleway',
                    lineHeight: '13px',
                    outline: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textDecoration: 'none',
                  }}
                >
                  {t('nav.intranet')}
                </a>
              </li>
            </>
          ) : (
            // Vista desktop y tablet sin cambios
            <>
              <li>
                <Link to="/" style={getLinkStyle('/')}>
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/nosotros" style={getLinkStyle('/nosotros')}>
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/oportunidades" style={getLinkStyle('/oportunidades')}>
                  {t('nav.opportunities')}
                </Link>
              </li>
              <li>
                <Link to="/hub" style={getLinkStyle('/hub')}>
                  {t('nav.hub')}
                </Link>
              </li>
              <li>
                <Link
                  to="https://grewhubtalks.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={getLinkStyle('https://grewhubtalks.com/')}
                >
                  {t('nav.talks')}
                </Link>
              </li>
              {/* <li>
                <button
                  onClick={toggleLanguage}
                  style={{
                    ...getLinkStyle('lang'),
                    border: '1px solid #697fa7',
                    backgroundColor: '#ffffff',
                    padding: isTablet ? '5px 10px' : '6px 12px',
                    borderRadius: '0',
                    cursor: 'pointer',
                    fontSize: isTablet ? '11px' : '12px',
                    fontFamily: 'Roboto',
                    fontWeight: 'normal',
                    textAlign: 'center',
                    lineHeight: '20px',
                    display: 'block',
                    width: 'auto',
                  }}
                >
                  {i18n.language && i18n.language.startsWith('es') ? t('lang.en') : t('lang.es')}
                </button>
              </li> */}
              <li>
                <a
                  href="https://intranet.grewhub.com/welcome"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    cursor: 'pointer',
                    padding: isTablet ? '5px 10px' : '6px 12px',
                    border: '1px solid #697fa7',
                    backgroundColor: '#ffffff',
                    color: '#697fa7',
                    fontSize: isTablet ? '11px' : '12px',
                    fontFamily: 'Roboto',
                    fontWeight: 'normal',
                    textAlign: 'center',
                    lineHeight: '20px',
                    textDecoration: 'none',
                    borderRadius: '0',
                    display: 'block',
                    width: 'auto',
                  }}
                >
                  {t('nav.intranet')}
                </a>
              </li>
            </>
          )}
        </ul>
      </nav>

      {/* Overlay para móvil cuando el menú está abierto */}
      {isMobile && isMenuOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 999,
          }}
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;
